"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
const colors_1 = require("../../common/colors");
const CloseButton = ({ buttonSize, iconSize = 16, inPlace, verticalOffset, horizontalOffset, tooltipLabel, onClose, }) => {
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const defaultVerticalOffset = (0, react_1.useMemo)(() => (inPlace ? 0 : 24), [inPlace]);
    const defaultHorizontalOffset = (0, react_1.useMemo)(() => (inPlace ? 0 : 24), [inPlace]);
    return ((0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: tooltipLabel || "Close Window", isOpen: isHovered, children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: onClose, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), style: [
                styles.button,
                {
                    width: buttonSize,
                    height: buttonSize,
                    position: inPlace ? 'relative' : 'absolute',
                    top: verticalOffset ?? defaultVerticalOffset,
                    right: horizontalOffset ?? defaultHorizontalOffset,
                    backgroundColor: isHovered ? `${colors_1.Colors.DARK_700}96` : `${colors_1.Colors.DARK_700}60`,
                },
            ], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTimes, size: iconSize, color: "white" }) }) }));
};
const styles = react_native_1.StyleSheet.create({
    button: {
        width: 32,
        height: 32,
        zIndex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 30,
    },
});
exports.default = CloseButton;
